module.exports = __webpack_public_path__ + "img/new-logo-white.f01a8f6a.png";